import React from "react";
import { IMAGES } from "../../lib/restaurantData";
import { Flame, Wheat, Heart } from "lucide-react";
import { useT } from "../../lib/i18n";

export const About = () => {
  const { t } = useT();
  const HIGHLIGHTS = [
    { icon: Flame, title: t("about.h1_title"), desc: t("about.h1_desc") },
    { icon: Wheat, title: t("about.h2_title"), desc: t("about.h2_desc") },
    { icon: Heart, title: t("about.h3_title"), desc: t("about.h3_desc") },
  ];

  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28 bg-[#F5EFE4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <span className="font-display text-xs tracking-[0.3em] text-[#B59410] font-semibold">
              {t("about.eyebrow")}
            </span>
            <h2 className="mt-4 font-script text-6xl sm:text-7xl lg:text-8xl text-[#1E3A5D] leading-[1]">
              {t("about.title")}
            </h2>
            <p className="mt-2 font-display text-sm text-[#1E3A5D]/70 tracking-[0.2em] font-semibold">
              {t("about.subtitle")}
            </p>
            <p className="mt-6 text-[#1E3A5D]/80 text-base sm:text-lg leading-relaxed font-serif-body">
              {t("about.p1")}
            </p>
            <p className="mt-4 text-[#1E3A5D]/80 text-base sm:text-lg leading-relaxed font-serif-body">
              {t("about.p2")}
            </p>

            <div className="mt-10 grid sm:grid-cols-1 gap-5">
              {HIGHLIGHTS.map((h, i) => {
                const Icon = h.icon;
                return (
                  <div key={i} data-testid={`highlight-${i}`} className="flex gap-4 items-start">
                    <div className="shrink-0 w-11 h-11 rounded-full bg-[#1E3A5D]/8 text-[#B59410] grid place-items-center">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-display text-base text-[#1E3A5D] tracking-[0.16em] font-semibold uppercase">{h.title}</h3>
                      <p className="text-[#1E3A5D]/70 text-sm sm:text-base mt-1 font-serif-body">{h.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-6 grid-rows-6 gap-4 h-[500px] sm:h-[640px]">
            <div className="col-span-4 row-span-4 rounded-2xl overflow-hidden shadow-sm">
              <img src={IMAGES.tableShot} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden shadow-sm">
              <img src={IMAGES.pizzaAction} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden bg-[#1E3A5D] text-white p-4 flex flex-col justify-end">
              <span className="font-script text-5xl text-[#E8C765] leading-none">15+</span>
              <span className="mt-1.5 font-display text-[10px] text-white/85 tracking-[0.2em]">{t("about.years")}</span>
            </div>
            <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden shadow-sm">
              <img src={IMAGES.spaghetti} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden shadow-sm">
              <img src={IMAGES.salmon} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden shadow-sm">
              <img src={IMAGES.scallops} alt="" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
